import { OvertimeWorkedAndScheduledPerPeriodModel } from '../models/OvertimeSchedule';
import { getTotalScheduledOvertimeForWeek, getTotalWorkedOvertimeForWeek } from './overtimeTotals.utils';

export type KpiVariant = 'success' | 'warning' | 'danger' | 'info' | 'primary';

const getRepresentativeDailyValue = (values: number[]): number => {
  if (!values.length) return 0;

  const allEqual = values.every((value) => value === values[0]);
  if (allEqual) return values[0];

  const sum = values.reduce((acc, value) => acc + value, 0);
  return Math.round((sum / values.length) * 10) / 10;
};

export const formatHours = (value: number): string => `${value.toFixed(2)} h`;

export const getAverageWorkedOvertimePerEmployee = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedPeriodIndex: number,
): number => {
  if (!data.length) return 0;

  const totalWorked = getTotalWorkedOvertimeForWeek(data, selectedPeriodIndex);
  return totalWorked / data.length;
};

export const getCompliancePercent = (data: OvertimeWorkedAndScheduledPerPeriodModel[], selectedPeriodIndex: number) => {
  const totalScheduled = getTotalScheduledOvertimeForWeek(data, selectedPeriodIndex);
  const totalWorked = getTotalWorkedOvertimeForWeek(data, selectedPeriodIndex);

  if (!totalScheduled) return 0;
  return Math.round((totalWorked / totalScheduled) * 100);
};

export const getComplianceVariant = (compliance: number): KpiVariant => {
  if (compliance >= 80) return 'success';
  if (compliance >= 65) return 'warning';
  return 'danger';
};
